import { SortDirection } from 'mapistry-shared';
import { SortState } from './types';

function getNextSortDirection(currentSortDirection: SortDirection | undefined) {
  // First click sorts column asc, second – desc, third – resets the sorting
  if (currentSortDirection === undefined) {
    return SortDirection.ASC;
  }
  if (currentSortDirection === SortDirection.ASC) {
    return SortDirection.DESC;
  }
  return undefined;
}

export function getNextSortDirectionForColumn(
  previousState: SortState | undefined,
  selectedColumnId: string | number,
) {
  const wasAlreadySortingByColumn =
    previousState?.columnId === selectedColumnId;

  return getNextSortDirection(
    wasAlreadySortingByColumn ? previousState.direction : undefined,
  );
}
